import type { IDatadogLogger } from './IDatadogLogger';

/**
 * Wrapper for the datadog logger that implements the IDatadogLogger interface.
 * It stops to log to datadog if it is over a certain maxNumberOfLogs.
 */
export class DatadogLoggerMaxNumberOfLogsWrapper implements IDatadogLogger {
  private logger: IDatadogLogger;
  private readonly maxNumberOfLogs: number = 1000;
  private count = 0;

  constructor(logger: IDatadogLogger, maxNumberOfLogs?: number) {
    this.logger = logger;
    if (maxNumberOfLogs) {
      this.maxNumberOfLogs = maxNumberOfLogs;
    }
  }

  debug(message: string, messageContext?: object, error?: Error): void {
    if (this.count < this.maxNumberOfLogs) {
      this.logger.debug(message, messageContext, error);
      this.count++;
    }
  }

  error(message: string, messageContext?: object, error?: Error): void {
    if (this.count < this.maxNumberOfLogs) {
      this.logger.error(message, messageContext, error);
      this.count++;
    }
  }

  info(message: string, messageContext?: object, error?: Error): void {
    if (this.count < this.maxNumberOfLogs) {
      this.logger.info(message, messageContext, error);
      this.count++;
    }
  }

  warn(message: string, messageContext?: object, error?: Error): void {
    if (this.count < this.maxNumberOfLogs) {
      this.logger.warn(message, messageContext, error);
      this.count++;
    }
  }
}
